import React from "react";

const Bash_If_Else = () => {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Bash If Else</h2>
      <p>Conditional branching.</p><pre><code>if [[ -f file.txt ]]; then
  echo exists
else
  echo missing
fi</code></pre>
    </div>
  );
};

export default Bash_If_Else;
